@if (eventSystem$ | async; as system){
    <app-event-system-headline [system]="system" />
    <div class="terms" [innerHTML]="system?.terms"></div>
}